import React from "react";

interface Props {
  address: server.dto.Address
}

const FormattedAddress = ({ address }: Props) => {
  return <>
    {address.formatted.map((line, i) =>
      <div key={`${i}|${line}`}>
        {line}
      </div>)}
  </>;
};

export default FormattedAddress;